import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpLinkComponent } from './fcp-link.component';

@NgModule({
    declarations: [FcpLinkComponent],
    imports: [CommonModule],
    exports: [FcpLinkComponent]
})
export class FcpLinkModule {}
